export const VERIFICATION_STATUS = {
  PENDING: "pending",
  APPROVED: "approved",
  REJECTED: "rejected",
} as const;

export const BUSINESS_FLAG_STATUS = {
  OPEN: "open",
  RESOLVED: "resolved",
} as const;

export const VERIFICATION_STATUS_OPTIONS = [
  { value: "", label: "All Status" },
  { value: VERIFICATION_STATUS.PENDING, label: "Pending" },
  { value: VERIFICATION_STATUS.APPROVED, label: "Approved" },
  { value: VERIFICATION_STATUS.REJECTED, label: "Rejected" },
];

export const VERIFICATION_STATUS_BADGE: Record<string, string> = {
  [VERIFICATION_STATUS.PENDING]: "light-warning",
  [VERIFICATION_STATUS.APPROVED]: "light-success",
  [VERIFICATION_STATUS.REJECTED]: "light-danger",
};

export const VERIFICATION_STATUS_LABEL: Record<string, string> = {
  [VERIFICATION_STATUS.PENDING]: "Pending",
  [VERIFICATION_STATUS.APPROVED]: "Approved",
  [VERIFICATION_STATUS.REJECTED]: "Rejected",
};

export const normalizeVerificationStatus = (status?: string | null) =>
  status?.toLowerCase() || VERIFICATION_STATUS.PENDING;

export const canApproveVerification = (status?: string | null) => {
  const key = normalizeVerificationStatus(status);
  return (
    key === VERIFICATION_STATUS.PENDING ||
    key === VERIFICATION_STATUS.REJECTED
  );
};

export const canRejectVerification = (status?: string | null) => {
  const key = normalizeVerificationStatus(status);
  return key === VERIFICATION_STATUS.PENDING;
};

export const isOpenBusinessFlag = (status: string) =>
  status === BUSINESS_FLAG_STATUS.OPEN;

export const COMPLIANCE_EVENT_TYPE = {
  VERIFICATION_PENDING: "verification_pending",
  VERIFICATION_APPROVED: "verification_approved",
  VERIFICATION_REJECTED: "verification_rejected",
  BUSINESS_FLAGGED: "business_flagged",
  INTERNAL_COMMENT: "internal_comment",
  WARNING_ISSUED: "warning_issued",
  SUSPENSION: "suspension",
} as const;

export const COMPLIANCE_EVENT_LABEL: Record<string, string> = {
  [COMPLIANCE_EVENT_TYPE.VERIFICATION_PENDING]: "Verification Pending",
  [COMPLIANCE_EVENT_TYPE.VERIFICATION_APPROVED]: "Verification Approved",
  [COMPLIANCE_EVENT_TYPE.VERIFICATION_REJECTED]: "Verification Rejected",
  [COMPLIANCE_EVENT_TYPE.BUSINESS_FLAGGED]: "Business Flagged",
  [COMPLIANCE_EVENT_TYPE.INTERNAL_COMMENT]: "Internal Comment",
  [COMPLIANCE_EVENT_TYPE.WARNING_ISSUED]: "Warning Issued",
  [COMPLIANCE_EVENT_TYPE.SUSPENSION]: "Suspension",
};

export const COMPLIANCE_EVENT_BADGE: Record<string, string> = {
  [COMPLIANCE_EVENT_TYPE.VERIFICATION_PENDING]: "light-warning",
  [COMPLIANCE_EVENT_TYPE.VERIFICATION_APPROVED]: "light-success",
  [COMPLIANCE_EVENT_TYPE.VERIFICATION_REJECTED]: "light-danger",
  [COMPLIANCE_EVENT_TYPE.BUSINESS_FLAGGED]: "light-danger",
  [COMPLIANCE_EVENT_TYPE.INTERNAL_COMMENT]: "light-info",
  [COMPLIANCE_EVENT_TYPE.WARNING_ISSUED]: "light-warning",
  [COMPLIANCE_EVENT_TYPE.SUSPENSION]: "light-dark",
};

export const BUSINESS_FLAG_REASON = {
  SUSPICIOUS_BEHAVIOR: "suspicious_behavior",
  DUPLICATE_CONTENT: "duplicate_content",
  CLIENT_REPORT: "client_report",
  OTHER: "other",
} as const;

export const BUSINESS_FLAG_REASON_LABEL: Record<string, string> = {
  [BUSINESS_FLAG_REASON.SUSPICIOUS_BEHAVIOR]: "Suspicious Behavior",
  [BUSINESS_FLAG_REASON.DUPLICATE_CONTENT]: "Duplicate Content",
  [BUSINESS_FLAG_REASON.CLIENT_REPORT]: "Client Report",
  [BUSINESS_FLAG_REASON.OTHER]: "Other",
};

export const formatBusinessFlagReason = (reason?: string | null) =>
  BUSINESS_FLAG_REASON_LABEL[reason ?? ""] ?? reason ?? "";

export const FLAG_REASON_OPTIONS = [
  { value: BUSINESS_FLAG_REASON.SUSPICIOUS_BEHAVIOR, label: "Suspicious Behavior" },
  { value: BUSINESS_FLAG_REASON.DUPLICATE_CONTENT, label: "Duplicate Content" },
  { value: BUSINESS_FLAG_REASON.CLIENT_REPORT, label: "Client Report" },
  { value: BUSINESS_FLAG_REASON.OTHER, label: "Other" },
] as const;
